/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsRegistrationFailTemplateData } from '../../models/mail-params-registration-fail-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendRegistrationFailMail$Params {
      body: MailParamsRegistrationFailTemplateData
}

export function sendRegistrationFailMail(http: HttpClient, rootUrl: string, params: SendRegistrationFailMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendRegistrationFailMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendRegistrationFailMail.PATH = '/sendMail/registration-fail';
